export const MESSAGING_INTEGRATION_PROVIDERS = [
  "whatsapp_evolution",
  "whatsapp_cloud",
  "whatsapp_uazapi",
  "instagram",
  "messenger",
] as const;

export type MessagingIntegrationProvider = (typeof MESSAGING_INTEGRATION_PROVIDERS)[number];

export type MessagingChannel = "whatsapp" | "instagram" | "messenger";

export function getMessagingChannelFromProvider(provider: string): MessagingChannel | null {
  if (
    provider === "whatsapp_evolution" ||
    provider === "whatsapp_cloud" ||
    provider === "whatsapp_uazapi"
  ) {
    return "whatsapp";
  }
  if (provider === "instagram") return "instagram";
  if (provider === "messenger") return "messenger";
  return null;
}

export const MESSAGING_CHANNEL_GROUPS: Array<{
  channel: MessagingChannel;
  label: string;
  providers: MessagingIntegrationProvider[];
}> = [
  {
    channel: "whatsapp",
    label: "WhatsApp",
    providers: ["whatsapp_evolution", "whatsapp_cloud", "whatsapp_uazapi"],
  },
  {
    channel: "instagram",
    label: "Instagram",
    providers: ["instagram"],
  },
  {
    channel: "messenger",
    label: "Messenger",
    providers: ["messenger"],
  },
];

export function isMessagingIntegrationProvider(provider: string): provider is MessagingIntegrationProvider {
  return (MESSAGING_INTEGRATION_PROVIDERS as readonly string[]).includes(provider);
}
